import React from "react";
import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";
import {useAppDispatch} from "../../../../../app/hooks";
import {OfferInListDTO, OfferStatus} from "../../../../../api/generated";
import {toggleOfferStatus} from "../../../../modules/offer/offerListSlice";

interface ConfirmationModalProps {
    offer: OfferInListDTO
    newOfferStatus: OfferStatus
    title: string
    subtitle: string
    yesButtonTitle: string
    handleClose: (value?: any) => any
}

export const OfferStatusChangeConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                         offer,
                                                                                         title,
                                                                                         subtitle,
                                                                                         yesButtonTitle,
                                                                                         newOfferStatus,
                                                                                         handleClose,
                                                                                     }) => {
    const dispatch = useAppDispatch()

    const handleArchive = () => {
        dispatch(toggleOfferStatus({offerStatus: newOfferStatus, publicOfferId: offer.publicId}))
        handleClose()
    }

    return <ConfirmationModal
        title={title}
        subtitle={subtitle}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={`Yes, ${yesButtonTitle}`}
        onConfirm={handleArchive}
        onClose={handleClose}
    />
}
